const seo = {
  pages: {
    home: {
      title: "Elite Dental Solutions | Οδοντιατρική κλινική",
      description:
        "Σύγχρονη οδοντιατρική κλινική με έμπειρη ομάδα και ανθρωποκεντρική προσέγγιση. Κλείστε δωρεάν συμβουλευτική και λάβετε εξατομικευμένο πλάνο θεραπείας.",
    },
    prices: {
      title: "Τιμές | Elite Dental Solutions",
      description:
        "Δείτε ενδεικτικές τιμές για οδοντιατρικές υπηρεσίες. Επικοινωνήστε μαζί μας για εξατομικευμένο πλάνο και ακριβή προσφορά.",
    },
    "request-quote": {
      title: "Δωρεάν συμβουλευτική | Elite Dental Solutions",
      description:
        "Στείλτε αίτημα και κλείστε δωρεάν συμβουλευτική. Η ομάδα μας θα επικοινωνήσει μαζί σας άμεσα για επιβεβαίωση των στοιχείων.",
    },
    "privacy-policy": {
      title: "Πολιτική Απορρήτου | Elite Dental Solutions",
      description:
        "Μάθετε πώς η Elite Dental Solutions συλλέγει, χρησιμοποιεί και προστατεύει προσωπικά δεδομένα και πώς μπορείτε να ασκήσετε τα δικαιώματά σας.",
    },
    "terms-of-service": {
      title: "Όροι Χρήσης | Elite Dental Solutions",
      description:
        "Διαβάστε τους Όρους Χρήσης της Elite Dental Solutions, συμπεριλαμβανομένων ραντεβού, πληρωμών, ευθυνών και προϋποθέσεων χρήσης της ιστοσελίδας.",
    },
    "not-found": {
      title: "404 | Elite Dental Solutions",
      description: "Η σελίδα δεν βρέθηκε.",
    },
    services: {
      implantology: {
        title: "Εμφυτεύματα | Elite Dental Solutions",
        description:
          "Οδοντικά εμφυτεύματα υψηλής ποιότητας με ακριβή σχεδιασμό και σύγχρονα υλικά. Μακροχρόνια λύση για λειτουργικότητα και αισθητική.",
      },
      endodontics: {
        title: "Ενδοδοντία | Elite Dental Solutions",
        description:
          "Θεραπεία ριζικών σωλήνων με σύγχρονες τεχνικές και προσοχή στη λεπτομέρεια. Ανακούφιση από πόνο και διατήρηση του φυσικού δοντιού.",
      },
      "oral-surgery": {
        title: "Στοματική χειρουργική | Elite Dental Solutions",
        description:
          "Στοματικές χειρουργικές πράξεις από έμπειρη ομάδα με έμφαση στην ασφάλεια. Συμβουλευτική, πλάνο θεραπείας και μετεγχειρητική φροντίδα.",
      },
      periodontology: {
        title: "Περιοδοντολογία | Elite Dental Solutions",
        description:
          "Φροντίδα ούλων και περιοδοντική θεραπεία για μακροχρόνια στοματική υγεία. Διάγνωση, θεραπεία και πρόληψη για υγιή ούλα.",
      },
      orthodontics: {
        title: "Ορθοδοντική | Elite Dental Solutions",
        description:
          "Ορθοδοντική θεραπεία για ευθυγραμμισμένα δόντια και ισορροπημένη σύγκλειση. Εξατομικευμένος σχεδιασμός και παρακολούθηση προόδου.",
      },
      bonding: {
        title: "Bonding | Elite Dental Solutions",
        description:
          "Αισθητικό bonding για μικρές διορθώσεις σε σχήμα και χρώμα. Συντηρητικός τρόπος για βελτίωση του χαμόγελου.",
      },
      prosthetics: {
        title: "Προσθετική | Elite Dental Solutions",
        description:
          "Προσθετικές λύσεις όπως στεφάνες, γέφυρες και οδοντοστοιχίες για άνεση και φυσική εμφάνιση. Ακριβής εφαρμογή και ανθεκτικά αποτελέσματα.",
      },
      "lip-filler": {
        title: "Lip Filler | Elite Dental Solutions",
        description:
          "Θεραπείες lip filler με φυσικό αποτέλεσμα και προσοχή στις αναλογίες. Συμβουλευτική και εξατομικευμένη προσέγγιση.",
      },
      cariesology: {
        title: "Τερηδόνα | Elite Dental Solutions",
        description:
          "Διάγνωση και θεραπεία τερηδόνας με ήπιες τεχνικές και ποιοτικά υλικά. Προστασία οδοντικών ιστών και αποκατάσταση αισθητικής.",
      },
      "teeth-whitening": {
        title: "Λεύκανση δοντιών | Elite Dental Solutions",
        description:
          "Επαγγελματική λεύκανση δοντιών στην κλινική ή στο σπίτι. Ασφαλή πρωτόκολλα και ορατά αποτελέσματα για πιο φωτεινό χαμόγελο.",
      },
      "dental-tourism": {
        title: "Οδοντιατρικός τουρισμός | Elite Dental Solutions",
        description:
          "Οδοντιατρικός τουρισμός στη Βουλγαρία με ολοκληρωμένη οργάνωση και υψηλής ποιότητας περίθαλψη. Λάβετε πλάνο, προσφορά και υποστήριξη για το ταξίδι σας.",
      },
    },
  },
};

export default seo;

